import {Icon} from 'front-onceforall-core';
import React from 'react';
import {Translate} from 'react-redux-i18n';
import {useHistory} from 'react-router-dom';
import {DISPLAY_REGISTRATION_HELP_LOCAL_STORAGE_KEY} from '../../utils/organisation';
import {pathResolver} from '../../utils/basePathHelper';

export const OrganisationRegisterHelpView = () => {
  const history = useHistory();

  React.useEffect(() => {
    // Once it has been displayed, remember that locally
    localStorage.setItem(DISPLAY_REGISTRATION_HELP_LOCAL_STORAGE_KEY, 'true');
  });

  const onRegisterClick = () => {
    history.push('/register-organisation');
  };

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-12 d-flex flex-column align-items-center">
          <h1 className="mb-0">
            <Translate value="registerFirstTime.title"/>
          </h1>
          <p>
            <Translate value="registerFirstTime.subtitle"/>
          </p>
        </div>
      </div>
      <div className="row mb-5">
        <div className="col-12 d-flex">
          <div className="d-flex flex-column align-items-center flex-fill">
            <img
              alt=""
              src={pathResolver('resources/svg/registration-first-time/network.svg')}
              height={100}
            />
            <p style={{textAlign: 'center'}}>
              <Translate value="registerFirstTime.network"/>
            </p>
          </div>
          <div className="d-flex flex-column align-items-center flex-fill">
            <img
              alt=""
              src={pathResolver('resources/svg/registration-first-time/view.svg')}
              height={100}
            />
            <p style={{textAlign: 'center'}}>
              <Translate value="registerFirstTime.view"/>
            </p>
          </div>
          <div className="d-flex flex-column align-items-center flex-fill">
            <img
              alt=""
              src={pathResolver('resources/svg/registration-first-time/import.svg')}
              height={100}
            />
            <p style={{textAlign: 'center'}}>
              <Translate value="registerFirstTime.import"/>
            </p>
          </div>
          <div className="d-flex flex-column align-items-center flex-fill">
            <img
              alt="network"
              src={pathResolver('resources/svg/registration-first-time/projet.svg')}
              height={100}
            />
            <p style={{textAlign: 'center'}}>
              <Translate value="registerFirstTime.participate"/>
            </p>
          </div>
        </div>
      </div>
      <div className="row box info mb-5">
        <h2
          className="col-12"
          style={{textAlign: 'center'}}
        >
          <strong><Translate value="registerFirstTime.optionsTitle"/></strong>
        </h2>
        <div className="col-12 d-flex">
          <div className="d-flex flex-column align-items-center flex-fill">
            <img
              alt="network"
              src={pathResolver('resources/svg/registration-first-time/new-organisation.svg')}
              height={100}
            />
            <p style={{textAlign: 'center'}}>
              <Translate value="registerFirstTime.newOrganisation"/>
            </p>
            <p style={{textAlign: 'center'}}>
              <strong><Translate value="registerFirstTime.newOrganisationSubtitle"/></strong>
            </p>
          </div>
          <div className="d-flex flex-column align-items-center flex-fill">
            <img
              alt=""
              src={pathResolver('resources/svg/registration-first-time/already.svg')}
              height={100}
            />
            <p style={{textAlign: 'center'}}>
              <Translate value="registerFirstTime.joinOrganisation"/>
            </p>
            <p style={{textAlign: 'center'}}>
              <strong><Translate value="registerFirstTime.joinOrganisationSubtitle"/></strong>
            </p>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-12 d-flex flex-column align-items-center">
          <h2 className="mb-5">
            <Translate value="registerFirstTime.start"/>
          </h2>
          <button
            type="button"
            className="large primary inline-container"
            onClick={onRegisterClick}
          >
            <Icon icon="plus"/>
            <Translate value="registerFirstTime.startButton"/>
          </button>
        </div>
      </div>
    </div>
  );
};

export default OrganisationRegisterHelpView;
